import React from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { ChecklistItems } from '../../../api/configurations/checklist/types';
import { AuthenticationTabs, MiscellaneousSettings } from '../../../components';
import { HeaderTitle, Preloader, ToDashboardError } from '../../../components/ui';
import { useChecklist, useCurrentProject } from '../../../contexts/settings';
import { useMiscellaneousData } from '../../../hooks';
import { RouteParams } from '../../../routes/types';

const Miscellaneous = ({ match }: RouteComponentProps): JSX.Element => {
  const { projectId } = match.params as RouteParams;
  const intl = useIntl();
  const { currentProjectFetching, error: projectError } = useCurrentProject(projectId);
  const { enableChecklistItem, checklistItems } = useChecklist(projectId);

  const { miscellaneousFetching, miscellaneousError, miscellaneousData, updateMiscellaneous } =
    useMiscellaneousData(projectId);

  if (miscellaneousData.length && !!checklistItems) {
    enableChecklistItem(ChecklistItems.MISCELLANEOUS_DATA);
  }

  if (currentProjectFetching || miscellaneousFetching) {
    return (
      <AuthenticationTabs>
        <Preloader />
      </AuthenticationTabs>
    );
  }

  if (projectError) {
    return <ToDashboardError error={projectError} pageName="miscellaneous-settings_open" />;
  }

  return (
    <AuthenticationTabs>
      <HeaderTitle
        title={intl.formatMessage({ id: 'miscellaneous.settings.title' })}
        subtitle={intl.formatMessage({ id: 'miscellaneous.settings.subtitle' })}
      />
      <MiscellaneousSettings
        isError={miscellaneousError}
        projectId={projectId}
        data={miscellaneousData}
        updateData={updateMiscellaneous}
      />
    </AuthenticationTabs>
  );
};

export default withRouter(Miscellaneous);
